import { Snackbar, Stack, IconButton } from "@mui/material";
import React, { useState } from "react";
import { TextView } from "../../../../components";
import { colors } from "../../../../utils";
import UserImage from "../../../../components/UserImage";
import { ASSETS } from "../../../../utils/config";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";

function ProfileCard({ profileData }) {
  console.log(profileData, "profileData");
  const {
    first_name,
    last_name,
    social_media_links,
    username,
    profile_image,
    bio,
    user_id,
  } = profileData;

  const [open, setOpen] = useState(false);

  const socialPlatforms = {
    youtube: ASSETS.youtubeIcon,
    facebook: ASSETS.profileFacebook,
    linkedin: ASSETS.bb_social_linkedin,
    twitter: ASSETS.bb_social_twitter,
    instagram: ASSETS.bb_social_instagram,
    tiktok: ASSETS.bb_social_tiktok,
  };

  const [isBioExpanded, setIsBioExpanded] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  return (
    <Stack
      style={{
        // height: "25vh",
        // alignItems: "center",
        padding: "5px",
        // backgroundColor: "#F6F7F9",
        backgroundColor: "white",
        borderRadius: "5px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Stack
        display={"flex"}
        flexDirection={"row"}
        style={{ width: "100%", padding: "5px" }}
        alignItems={"center"}
      >
        <UserImage image={profile_image} size={60} />

        <Stack ml={1}>
          <TextView
            style={{
              color: colors.primary,
              fontWeight: "700",
              fontSize: "20px",
            }}
          >
            {first_name} {last_name}
          </TextView>
          <TextView
            style={{
              color: colors.darkGrey,
              fontSize: "16px",
            }}
          >
            {username}
          </TextView>
        </Stack>
        <img
          onClick={() => {
            setOpen(true);
            navigator.clipboard.writeText(
              window.location.origin + "/otheruserprofile/" + user_id
            );
          }}
          src={ASSETS.share}
          alt="share"
          style={{
            height: "20px",
            width: "20px",
            marginTop: "-20px",
            marginLeft: "10px",
          }}
        />
      </Stack>

      {isBioExpanded ? (
        <TextView
          style={{
            color: colors.darkGrey,
            marginLeft: "4px",
            marginRight: "4px",
            fontSize: "14px",
          }}
          onClick={() => setIsBioExpanded(!isBioExpanded)}
        >
          {bio}
        </TextView>
      ) : (
        <TextView
          style={{
            display: "-webkit-box", // Use the webkit box model for the container
            WebkitBoxOrient: "vertical", // Set the box orientation to vertical
            WebkitLineClamp: 3, // Limit the content to 3 lines
            overflow: "hidden", // Hide the overflow content
            textOverflow: "ellipsis", // Add an ellipsis to any overflow text
            color: colors.darkGrey,
            marginLeft: "4px",
            marginRight: "4px",
            fontSize: "14px",
          }}
          onClick={() => setIsBioExpanded(true)}
        >
          {bio}
        </TextView>
      )}

      {
        !isBioExpanded && bio && bio.length > 100 ? (
          <TextView
            onClick={(e) => {
              e.preventDefault();
              setIsBioExpanded(true);
            }}
            style={{
              color: colors.darkBlue,
              cursor: "pointer",
              fontSize: "14px",
              marginLeft: "4px",
              fontWeight: "500",
              zIndex: 1000,
            }}
          >
            See more
          </TextView>
        ) : null
        // (
        //   <TextView
        //     onClick={(e) => {
        //       e.preventDefault();
        //       setIsBioExpanded(false);
        //     }}
        //     style={{
        //       color: colors.darkBlue,
        //       cursor: "pointer",
        //       fontSize: "14px",
        //       marginLeft: "4px",
        //       fontWeight: "500",
        //       zIndex: 1000,
        //     }}
        //   >
        //     See less
        //   </TextView>
        // )
      }

      {social_media_links && social_media_links["website"] ? (
        <Stack
          style={{
            display: "flex",
            flexDirection: "row",
            padding: 10,
            alignItems: "center",
            borderRadius: 20,
            marginBottom: 5,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <img
            alt="weblogo"
            src={ASSETS.website}
            style={{
              width: 18,
              height: 18,
              marginRight: 5,
            }}
          />
          <a
            href={social_media_links["website"]}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TextView
              variant="text"
              color={colors.darkBlue}
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                fontSize: "14px",
              }}
            >
              {social_media_links["website"]?.slice(0, 20)}
            </TextView>
          </a>

          <Stack
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              background: colors.lightGrey,
              padding: 0.3,
              borderRadius: 10,
              pl: 1,
              pr: 1,
              ml: 2,
              cursor: "pointer",
            }}
            onClick={() => {
              setOpen(true);
              navigator.clipboard.writeText(social_media_links["website"]);
            }}
          >
            <ContentCopyIcon style={{ fontSize: "12px", marginRight: "3px" }} />
            <TextView
              style={{
                fontSize: "9px",
              }}
              variant="tag"
            >
              Copy
            </TextView>
          </Stack>
        </Stack>
      ) : null}

      <Stack
        direction={"row"}
        gap={2}
        style={{ width: "100%", marginLeft: "10px", zIndex: 1000 }}
        mt={social_media_links && social_media_links["website"] ? -1 : 1}
        mb={1}
      >
        {social_media_links &&
          Object.keys(social_media_links).map((link) => {
            if (link && link !== "website")
              return (
                <a
                  href={social_media_links[link]}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    style={{ borderRadius: 15 }}
                    width={25}
                    height={25}
                    src={socialPlatforms[link]}
                    alt={link}
                  />
                </a>
              );
          })}
      </Stack>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message={`Link copied to clipboard!`}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
    </Stack>
  );
}

export default ProfileCard;
